import {ExtendedProductTypeCode} from '@amplify/athena-models';
import {actions, categories, pushEvent} from '../../helpers/analyticsEvents';
import {RootStore} from '../../store/Store';

const createChart = async (elemId: string, chartConfig: any): Promise<any> => {
    const {Chart, registerables} = await import('chart.js');
    Chart.register(...registerables);
    const canvas = document.getElementById(elemId) as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');
    return new Chart(ctx, {...chartConfig});
};

const toNextPhase = (context: RootStore, productType: ExtendedProductTypeCode): void => {
    const phase = context.userData.phase3;
    pushEvent(categories.quotes, actions.getApproved);
    phase.approveQuoteNew(productType).then(() => {
        context.uiStore.progressStore.toNextPhase();
    });
};

const COEFFICIENT = 1.05;
const IIR = 0.065;
const AGES = [5, 10, 15, 20, 25, 30, 35];
const PREMIUM_STEP = 100;

const CHECKBOXES = {
    critical: 'critical',
    chronic: 'chronic',
};

export {AGES, CHECKBOXES, COEFFICIENT, createChart, IIR, PREMIUM_STEP, toNextPhase};
